import { render, staticRenderFns } from "./chatWindow.vue?vue&type=template&id=2a7c9c10&scoped=true"
import script from "./chatWindow.vue?vue&type=script&lang=js"
export * from "./chatWindow.vue?vue&type=script&lang=js"
import style0 from "./chatWindow.vue?vue&type=style&index=0&id=2a7c9c10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7c9c10",
  null
  
)

export default component.exports